export default {
  de: {
    title: 'Neuen Ziel Status hinzufügen',
    name: 'Name',
    submit: 'Ziel Status erstellen',
    back: 'Zurück',
    alerts: {
      500: () => 'Ein unbekannter Fehler ist aufgetretten! Bitte versuchen Sie es in kürze erneut!',
    },
  },
};
